import styled from 'styled-components/macro';
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from '../../../../app/constants';
import { MOBILE_PADDING } from '../../../Results/constants';
import { APP_WIDTH } from '../../styledComponents';

export const Header = styled.header`
  min-height: 11.2rem;
  display: flex;
  flex-direction: column;
  padding-bottom: 3rem;
  margin-bottom: 3rem;
  position: relative;
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    padding: 0 ${MOBILE_PADDING}px;
  }
  .header-menu {
    position: fixed;
    z-index: 9999;
    background: white;
    width: 100%;
    left: 0;
    &__inner {
      max-width: ${APP_WIDTH};
      border-bottom: ${(props) => `1px solid ${props.theme.grey.light}`};
      display: flex;
      align-items: center;
      height: 8.2rem;
      margin: 0 auto;
    }
    &__search {
      position: fixed;
      left: 50%;
      transform: translate(-50%, 0);
      top: 50px;
      z-index: 99999;
      @media (max-width: ${TABLET_BREAKPOINT}px) {
        position: fixed;
        transform: none;
        left: 15%;
        right: 15%;
        max-width: none;
        width: auto;
        top: 66px;
      }
      @media (max-width: ${MOBILE_BREAKPOINT}px) {
        left: 10px;
        right: 10px;
      }
    }
    &__item {
      color: ${(props) => props.theme.fontColor.primary};
      padding: 0 2rem;
      font-size: 1.6rem;
      font-weight: 800;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .lbl {
        margin-left: 10px;
        max-width: 190px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: ${TABLET_BREAKPOINT}px) {
          display: none;
        }
      }
      &-link {
        color: ${(props) => props.theme.fontColor.primary};
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-bottom: 2px solid transparent;
        height: 100%;
        &.active {
          color: ${(props) => props.theme.accent};
          border-color: ${(props) => props.theme.accent};
        }
      }
      &:hover,
      &:focus {
        .header-menu__item-link {
          color: ${(props) => props.theme.accent};
        }
      }
      &:not(:last-child) {
        &:before {
          position: absolute;
          content: '';
          right: 0;
          width: 1px;
          height: 2rem;
          top: 50%;
          transform: translateY(-50%);
          background-color: ${(props) => props.theme.grey.light};
        }
      }
      &:hover,
      &:focus {
        text-decoration: none;
      }
    }
  }
`;
